<template>
	<b-modal
		header-class="header-class-modal-doc-package"
		v-model="isOpen"
		:title="title"
		size="xl"
		hide-header-close
		centered
		cancel-variant="light"
		no-close-on-backdrop
		no-close-on-esc
	>
		<!-- <pre>{{ item }}</pre> -->
		<div class="container-layout">
			<script-form
				ref="form"
				:display-submit-btn="false"
				:action="action"
				:item="item"
				:odoo-back-log-xid="odooBackLogXid"
				@script-form:successed="reloadList"
				@script-form:loading="onLoaded"
			/>
		</div>
		<template #modal-footer>
			<div class="w-100 d-flex justify-content-end align-items-center">
				<b-button size="md" variant="light" @click="emitEventClose" class="w-160-px" block>
					{{ FormMSG(1, 'Cancel') }}
				</b-button>
				<b-button size="md" variant="primary" :disabled="watingSubmitForm" @click="dispatchEvent" style="margin-top: 0px" class="w-160-px mx-3" block>
					<div class="d-flex justify-content-center align-items-center">
						<b-spinner v-show="watingSubmitForm" small />
						<div class="pl-2" style="margin-top: -1px">{{ FormMSG(2, 'Save') }}</div>
					</div>
				</b-button>
			</div>
		</template>
	</b-modal>
</template>
<script>
import languageMessages from '@/mixins/languageMessages';
import globalMixin from '@/mixins/global.mixin';
import ScriptForm from '@/views/script/_id';
import { SCRIPT_TYPE } from '@/shared/constants';

export default {
	name: 'ScriptFormModal',
	mixins: [languageMessages, globalMixin],
	props: {
		value: {
			type: Boolean,
			required: false,
			default: false
		},
		title: {
			type: String,
			required: true,
			default: ''
		},
		item: {
			type: Object,
			required: true,
			default: () => {}
		},
		action: {
			type: String,
			required: true,
			default: ''
		},
		odooBackLogXid: {
			type: String,
			required: false,
			default: null
		}
	},
	components: {
		ScriptForm
	},
	computed: {
		isOpen: {
			get: function () {
				return this.value;
			},
			set: function (value) {
				return value;
			}
		}
	},
	data() {
		return {
			watingSubmitForm: false,
			SCRIPT_TYPE
		};
	},
	methods: {
		emitEventClose() {
			this.$emit('script-form-modal:closed');
		},
		dispatchEvent(e) {
			e.preventDefault();
			this.$refs['form'].$refs['submit'].click();
		},
		reloadList(payload) {
			if (payload) {
				this.$emit('script-form-modal:closed');
				this.$emit('script-form-modal:successed', payload);
			}
		},
		onLoaded(payload) {
			this.watingSubmitForm = payload;
		}
	}
};
</script>
